module.exports = __webpack_public_path__ + "static/media/logo-nico.0742c1c2.svg";